import {
    INLINE_BUTTON,
    INLINE_EMOJI,
    INLINE_EXPRESSION,
    INLINE_ICON,
    INLINE_IMAGE,
    INLINE_LINK,
    INLINE_MATH,
} from '@gitbook/doc-core';

export const INLINE_CONTROLS = [
    INLINE_IMAGE,
    INLINE_EMOJI,
    INLINE_LINK,
    INLINE_MATH,
    INLINE_EXPRESSION,
    INLINE_BUTTON,
    INLINE_ICON,
] as const;

export type InlineControl = (typeof INLINE_CONTROLS)[number];

export type InlineControls = Array<InlineControl>;

export type InlineControlsMarkData = {
    value: string;
    controls: InlineControls;
};
